import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.INVITE_WIZARD,
    loadComponent: () =>
      import('./invite-wizard.component').then((m) => m.InviteWizardComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.INVITE_WIZARD,
    loadComponent: () =>
      import('./invite-wizard.component').then((m) => m.InviteWizardComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InviteWizardModule {}
